<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Construction Industry Scheme</h1>
    <p>Do you employ subcontractors or act as a subcontractor requiring CIS deductions suffered?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.hasCisSubContractors">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.hasCisSubContractors">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.hasCisSubContractors === undefined || props.formData.hasCisSubContractors === null || props.formData.hasCisSubContractors === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}


const executeStep = async () => {
  return true;
}




defineExpose({ validateStep, executeStep });

</script>